import { createStore } from 'vuex'

export const dataFighters = createStore({
  state: () => {
    return {
      name: undefined,
      phone: undefined,
      email: undefined,
      password: {
        old: undefined,
        newPass: undefined,
        confirm: undefined
      },
      image: undefined,
      imgPath: undefined,
      amount: undefined,
      percent: undefined,

      myEvents: [],
      fighters: [],
      events: [],
      nextAndAllEvents: []
    }
  },
  getters: {
    getPermissionType: (state) => state.permission_type,
    getFighters: (state) => state.fighters,
    getEvents: (state) => state.events,
    getMyEvents: (state) => state.myEvents,
    getCollectionByFilter: (state) => state.nextAndAllEvents
    // getis_freela: (state) => state.is_freela,
    // getfreela_in_service: (state) => state.freela_in_service,
    // gethourForLunch: (state) => state.hourForLunch,
    // getreturnForLunch: (state) => state.returnForLunch,
    // getentry_time: (state) => state.entry_time,
    // getclosing_time: (state) => state.closing_time
  },
  mutations: {
    reset (state) {
      state.name = undefined
      state.phone = undefined
      state.email = undefined
      state.amount = undefined
      state.percent = undefined
      state.myEvents = []
      state.events = []
    },
    updateCollabFields (state, payload) {
      Object.assign(state, payload)
      state.myEvents = payload.coupon
      state.image = payload.avatar
      state.imgPath = payload.avatar
    },
    setCollabSettings (state, payload) {
      // state.turno = payload
    },
    SET_FIGHTERS_COLLECT (state, payload) {
      state.fighters = []
      state.fighters = payload
    },
    SET_EVENTS_COMBO (state, payload) {
      state.events = []
      state.events = payload
    },
    SET_COLLECT_VALUE (state, value) {
      state.myEvents = value
    },
    REMOVE_ITEM_BY_COLLECT_VALUE (state, value) {
      state.myEvents.splice(value, 1)
    },
    SET_MY_EVENTS (state, events) {
      state.nextAndAllEvents = events
    }
  },
  actions: {
    setCollabSettings ({ commit }, value) {
      commit('setCollabSettings', value)
    },
    setFightersCollect ({ commit }, value) {
      commit('SET_FIGHTERS_COLLECT', value)
    },
    setComboEvents ({ commit }, value) {
      commit('SET_EVENTS_COMBO', value)
    },
    setCollectValue ({ commit }, val) {
      commit('SET_COLLECT_VALUE', val)
    },
    removeItemByCollectValue ({ commit }, val) {
      commit('REMOVE_ITEM_BY_COLLECT_VALUE', val)
    }
  }
})
